



























import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "ResetPasswordComplete",
  components: {},
  directives: {},
})
export default class ResetPasswordComplete extends Vue {
  public isShow = false;

  public mounted() {
    console.log(this.isShow);
  }

  public show() {
    console.log("SHOW");
    this.isShow = true;
  }
}
